import React, { useState, useEffect } from "react";
import littleGuy from "../../TDD-Images/little-guy-alone_2.png";
import { capitalizeFirstLetter, formatDateWithTime, generateGUID, getPackName, hasMultipleQuestionPacks, parseQuestionQuery } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { companyOptions, JobDescription, SessionQuestion, track, type, User } from '@/utils/types';
import buddy from '../../TDD-Images/buddysteppingstone.png'
import { useAppContext } from "../appContext";
import TrackSessionQuestion from "./TrackSessionQuestion";



const SessionCompletePage = () => {

  const {state, navigateThenRun, showPastFeedback  } =
    useAppContext();

  const navigate = useNavigate();

  function getAttemptedQuestions() {
    var cont: JSX.Element[] = [];
    const ansqs = state.profileUser!.answeredQuestions;
    let questions: string[] = [];
    if (ansqs) {
      questions = Object.keys(ansqs);
    }
    for (let i = 0; i < questions.length; i++) {
      const que= questions[i];
      cont[i] = (
        <React.Fragment key={`q${generateGUID()}`}>
          {/* TODO: UPDATE FOR STARS */}
          <TrackSessionQuestion
          showCheckbox = {false}
            question={{ //this is a pseudo question
              question: {
                question: que,
                domain: "",
                level: "",
                specType: ansqs?.[que][0].specType ?? "",
                subCategories: [],
                type: "",
              },
              difficulty: "General",
              noOfStars: ansqs?.[que][ansqs?.[que].length - 1].stars||0,//from recent attempt
              selected: false,
              tag: ansqs?.[que][0].specType ?? "",
              tagColor: "text-[#000]",
            }}
            dropDownOptions={ansqs![que].slice().reverse().map((q, i) => ({
              label:
                "timestamp" in q
                  ? formatDateWithTime(
                    q["timestamp"].slice(0, q["timestamp"].lastIndexOf(":"))
                  )
                  : `${i}`,
              value: `${i}`,
              parent: que,
              noOfStars: q["stars"]||0,
            }))}
            setSelectedQuestions={() => { }}
            navigate={(e:string, i:string) => { AttemptedQuestionSelected!(e, Number(i))}}
          />
        </React.Fragment>
      );
    }
    return cont.reverse();
  }

  const AttemptedQuestionSelected = (e:string, i:number )=>{
    navigateThenRun(() => showPastFeedback(e, i), "/pastfeedback");
  }

  const NavigateToQBank = () => {
    navigate('/track');
  }

  return (
    <div className='full-nav'>
      <div className="dashboardScreen">
        <div className='dashboardContent'>
          <div className="flex-col w-[100%] items-start">
            <div className="flex-col items-start">
              <p className="text-customBlack text-lg mb-3">{`Nice work, ${state.profileUser?.name.split(' ')[0] || ""}`}</p>
              <div className="flex justify-between w-[100%]">
                <p className="font-bold text-grayBlue text-5xl">You've completed a session!</p>
              </div>
              {/* <p className="text-customBlack text-lg mt-4 w-[65%] text-left">Great job, you're well on your way to landing the role of your dreams.</p> */}
              <div className="mt-4 flex items-start">
                <img src={buddy} className="buddy mt-5" alt="buddy" />
                <div className="flex-col gap-3 shadow-sm mb-5 ml-2 p-3 bg-white w-[65%]">

                  <div className='text-left w-[100%]'>
                    <div className=""><p className='mr-5 text-grayBlue text-2xl mb-1' >Great job</p>
                      <p className='text-customBlack mb-2'>You're well on your way to landing the role of your dreams.</p>
                      <div className='flex justify-start gap-2'>
                        <div className='px-3 py-2 cursor-pointer text-white font-[300] hover:bg-orangeButton-hover bg-orangeButton rounded-md shadow-sm' onClick={() => navigateThenRun(null, "/")}><p>Dashboard</p></div>
                        {state.track !== track.CUSTOM && <div className='px-3 py-2 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={() => NavigateToQBank()}><p>Keep Practicing</p></div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-col align-self-start self-start">
                <p className="mt-2 mb-4 text-grayBlue font-bold">Here's a look at how you did</p>
              </div>
              {getAttemptedQuestions()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

      export default SessionCompletePage;